import { createSelector } from "reselect";
import { get, forOwn } from "lodash";

export const selectUsers = ({ ProfileEdit_reducer }) => {
    return ProfileEdit_reducer.users;
};

export const selectUserProfileUID = ({ ProfileEdit_reducer }) => {
    return ProfileEdit_reducer.selectedUserUID;
};
export const selectTab = ({ ProfileEdit_reducer }) => {
    return ProfileEdit_reducer.selectedTab;
};
export const selectUploadedImage = ({ ProfileEdit_reducer }) => {
    return ProfileEdit_reducer.uploadedImage;
};
export const getQualificationList = ({ Qualifications_reducer }) => {
    return Qualifications_reducer.qualificationList;
};

export const getProfileList = createSelector(
    [getQualificationList],
    qualifications => {
        if (qualifications === false) {
            return [];
        }

        let qualificationDetailsList = [];
        forOwn(qualifications, e => {
            qualificationDetailsList.push(e);
        });
        return qualificationDetailsList;
    }
);
export const selectUsernames = createSelector(
    [selectUsers],
    users => {
        if (users === false) {
            return [];
        }

        const result = Object.keys(users).map(uid => {
            const firstName = get(users[uid], "profile.first_name");
            const lastName = get(users[uid], "profile.last_name");
            const deleted = get(users[uid], "profile.deleted");
            if (typeof firstName === "undefined" || typeof lastName === "undefined") {
                return "Name Undefined";
            }

            return { name: `${firstName} ${lastName}`, deleted: deleted, uid };
        });

        return result.filter(e => {
            if (e.deleted !== true) {
                return true;
            } else {
                return false;
            }
        });
    }
);

export const selectedUser = createSelector(
    [selectUsers, selectUserProfileUID],
    (users, userProfileUID) => {
        return {
            uuid: userProfileUID,
            user: users[userProfileUID]
        };
    }
);
